import "../assets/useImageStyles.css";
import { h as I, defineComponent as P, ref as g, watchEffect as x, openBlock as b, createElementBlock as A, createBlock as L, unref as $, createCommentVNode as M, computed as v } from "vue";
import { l as w } from "./useStore.A2t3spKQ.js";
import { g as k } from "./Text.vue_vue_type_style_index_0_lang.BljMcTOj.js";
import { D as h } from "./maps.BW3odNwk.js";
const H = (l, e) => {
  const a = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5 3.25A1.75 1.75 0 003.25 5v6.523l2.886-2.887.01-.01c.5-.48 1.11-.767 1.77-.767.66 0 1.271.287 1.77.767l.011.01 1.97 1.97.303-.303.01-.01c.5-.48 1.11-.768 1.77-.768.66 0 1.27.287 1.77.768l.01.01 1.22 1.22V5A1.75 1.75 0 0015 3.25H5zm11.75 10.394l-2.275-2.275c-.272-.26-.523-.344-.725-.344-.202 0-.453.084-.725.344l-.298.298 1.137 1.136a.75.75 0 01-1.061 1.06l-1.666-1.665-.001-.002-2.494-2.493c-.272-.26-.523-.344-.725-.344-.202 0-.453.083-.726.344L3.25 13.644V15A1.75 1.75 0 005 16.75h10A1.75 1.75 0 0016.75 15v-1.356zM1.75 15A3.25 3.25 0 005 18.25h10A3.25 3.25 0 0018.25 15V5A3.25 3.25 0 0015 1.75H5A3.25 3.25 0 001.75 5v10zm10-8.333a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H12.5a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (l.title) {
    const n = document.createElementNS(a, "title");
    n.textContent = l.title, o.appendChild(n);
  }
  const c = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((n, u) => ({
    ...n,
    [u.name]: u.value
  }));
  return I(
    "svg",
    {
      ...c,
      ...e.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, C = ["data-module-id", "data-no-image"], W = ["data-image-loaded", "src", "alt"], T = /* @__PURE__ */ P({
  __name: "ImageWithBehaviour",
  props: {
    moduleProps: {},
    maxWidth: {},
    maxHeight: {}
  },
  setup(l) {
    const e = l, a = g(), r = g(), o = g(), c = g(e.maxWidth), n = g(e.maxHeight), u = g(!1), d = g(!1), t = g(1), i = w();
    function p() {
      if (a.value) {
        const {
          naturalWidth: m,
          naturalHeight: s
        } = a.value;
        t.value = m / s, u.value = !0;
      }
    }
    function f(m) {
      u.value = !1, d.value = !0;
      const s = new Image();
      s.onload = () => {
        r.value = m, s.remove();
      }, s.onerror = () => {
        r.value = null, s.remove();
      }, s.src = m;
    }
    x(() => {
      if (e.moduleProps.image) {
        const m = i == null ? void 0 : i.literals.getLocaleImageUrl(e.moduleProps.image);
        m && m !== r.value && f(m), o.value = i == null ? void 0 : i.literals.getLocaleImageUrl(e.moduleProps.image);
      }
    }), x(() => {
      const m = e.moduleProps.maxWidth ? Math.min(e.moduleProps.maxWidth, e.maxWidth) : e.maxWidth;
      n.value = Math.min(e.maxHeight, m / t.value), c.value = n.value * t.value;
    });
    function _() {
      const m = k(e.moduleProps.behaviour.type);
      i == null || i.handlers.callHandler(m, e.moduleProps.id);
    }
    return (m, s) => (b(), A("div", {
      class: "thn--tool-image-with-behaviour",
      "data-module-id": e.moduleProps.id,
      "data-no-image": !r.value && !d.value,
      onClick: _
    }, [
      !r.value && !d.value ? (b(), L($(H), {
        key: 0,
        class: "thn--tool-image-with-behaviour__icon"
      })) : M("", !0),
      r.value ? (b(), A("img", {
        key: 1,
        class: "thn--tool-image-with-behaviour__image",
        ref_key: "imageDom",
        ref: a,
        "data-image-loaded": u.value,
        src: r.value,
        alt: o.value,
        onLoad: p
      }, null, 40, W)) : M("", !0)
    ], 8, C));
  }
});
function V(l, e) {
  const a = w(), r = v(() => {
    var t;
    return (t = l.value) != null && t.image ? a == null ? void 0 : a.literals.getLocaleImageUrl(l.value.image) : "";
  }), o = v(() => {
    var t;
    return (t = l.value) != null && t.imageMobile ? a == null ? void 0 : a.literals.getLocaleImageUrl(l.value.imageMobile) : "";
  }), c = v(() => {
    var t;
    return (t = l.value) != null && t.image ? a == null ? void 0 : a.literals.getLocaleImageAlt(l.value.image) : "";
  }), n = v(() => {
    var t;
    return (t = l.value) != null && t.imageMobile ? a == null ? void 0 : a.literals.getLocaleImageAlt(l.value.imageMobile) : "";
  }), u = v(() => e.value === h.Mobile && o.value ? o.value : r.value), d = v(() => e.value === h.Mobile && n.value ? n.value : c.value);
  return {
    imageUrl: u,
    imageAlt: d
  };
}
const E = (l, e, a = g("left")) => ({
  imageStyles: v(() => {
    var p, f;
    if (e.value === h.Desktop && !((p = l.value) != null && p.imagePadding) || e.value === h.Mobile && !((f = l.value) != null && f.imageMobilePadding)) return "";
    const o = e.value === h.Mobile ? l.value.imageMobilePadding : l.value.imagePadding;
    if (!o) return "";
    const {
      top: c,
      bottom: n,
      left: u,
      right: d,
      format: t
    } = o, i = {
      top: `${c}${t}`,
      bottom: a.value !== "top" ? `${n}${t}` : "0px",
      right: a.value !== "left" ? `${d}${t}` : "0px",
      left: a.value !== "right" ? `${u}${t}` : "0px"
    };
    return `
      padding: ${i.top} ${i.right} ${i.bottom} ${i.left};
    `;
  })
});
export {
  T as _,
  E as a,
  H as i,
  V as u
};
//# sourceMappingURL=useImageStyles.BANS175F.js.map
